import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HighlightClassColorEnum, HighlightTypeEnum } from 'common/src/modules/ui-components/table-summary-bar/table-summary-bar.model';
import { TrackInputChanges } from 'projects/workspace/src/app/shared/decorators/track-input-changes';
import { ChangesStrategy } from 'projects/workspace/src/app/shared/enums/change-strategy.enum';

@Directive({
  selector: '[rnplHighlightColor]',
})
export class HighlightColorDirective implements OnChanges {
  protected _elementClass: string[] = [];

  @Input('highlightColorValue') value: number;

  @Input('highlightColorTypes') types: HighlightTypeEnum[];

  @HostBinding('class')
  get elementClass(): string {
    return this._elementClass.join(' ');
  }

  @TrackInputChanges<number>('value', 'updateClassesFromTypes', ChangesStrategy.Each)
  @TrackInputChanges<number>('types', 'updateClassesFromTypes', ChangesStrategy.Each)
  ngOnChanges(changes: SimpleChanges): void {}

  public updateClassesFromTypes(): void {
    if (!this.types || (!this.value && this.value !== 0)) {
      // console.warn(`Missing arguments for [rnplHighlightColor], highlightColorValue: ${this.value}, highlightColorTypes: ${this.types}`);
      return;
    }

    const selectedClasses = [];

    this.types.map((highlightType: HighlightTypeEnum) => {
      switch (highlightType) {
        case HighlightTypeEnum.POSITIVE_TO_GREEN:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.GREEN); }
          break;
        case HighlightTypeEnum.POSITIVE_TO_GREEN_400:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.GREEN_400); }
          break;
        case HighlightTypeEnum.POSITIVE_TO_RED:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.RED); }
          break;
        case HighlightTypeEnum.POSITIVE_TO_RED_LIGHT:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.RED_LIGHT); }
          break;
        case HighlightTypeEnum.POSITIVE_TO_ORANGE:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.ORANGE); }
          break;
        case HighlightTypeEnum.POSITIVE_TO_YELLOW:
          if (this.value > 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.YELLOW); }
          break;
        case HighlightTypeEnum.NEGATIVE_TO_GREEN:
          if (this.value < 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.GREEN); }
          break;
        case HighlightTypeEnum.NEGATIVE_TO_RED:
          if (this.value < 0) { this.addUniqClass(selectedClasses, HighlightClassColorEnum.RED); }
          break;
        // TODO - write code for another types
        default:
          break;
      }
    });
    this._elementClass = selectedClasses;
  }

  public addUniqClass(selectedClasses: string[], classToInsert: HighlightClassColorEnum): void {
    if (!selectedClasses.find((cls) => cls === classToInsert)) {
      selectedClasses.push(classToInsert);
    }
  }
}
